//@ flow

import WinList from './WinList'
export default WinList